/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:1;display:flex;flex-direction:column;box-sizing:border-box;margin-bottom:48px;overflow-y:auto}.fixed-bottom[_ngcontent-%COMP%]{position:fixed;bottom:0;width:100%}mat-tab-nav-bar[_ngcontent-%COMP%]{background-color:#9acd32;color:#fff}.mat-tab-nav-bar[_ngcontent-%COMP%]{background-color:#0b184e;color:#fff}.mat-tab-link[_ngcontent-%COMP%], mat-tab-link[_ngcontent-%COMP%]{color:#fff}.car-icon[_ngcontent-%COMP%]{height:38px;margin-top:5px}"];
export { styles as styles };
